import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer id="siteFooter" className="fixed inset-x-0 bottom-0 p-4">
      <div className="text-right">
        <strong>Copyright</strong> Webcastcloud {currentYear}
      </div>
    </footer>
  );
};

export default Footer;
